import { MotorhomeTabContent } from '@/components/blocks/MotorhomeDetails/MotorhomeTabContent';
import Container from '@/components/global/Container';
import { TitleAndDescription } from '@/components/shared/TitleAndDescription';
import { IComponentBlocksMotorhomeDetails } from '@/graphql/__generated__/global/types';
import { ILocales } from '@/interfaces/locales.interfaces';
import { FeatureList } from '@jucy/rentals-api-client/dist/rentals-api-v3';
import { useRouter } from 'next/router';
import products from 'public/products.json';

export enum IMotorhomeTabsTitles {
    Features = 'Features',
    Specifications = 'Specifications',
    ExcessReduction = 'Excess Reduction',
}
export enum IMotorhomeTabsNames {
    Features = 'features',
    Specifications = 'specifications',
    ExcessReduction = 'excess-reduction',
}

export const motorhomeTabNames = Object.keys(IMotorhomeTabsTitles) as unknown as (keyof typeof IMotorhomeTabsTitles)[];
export interface IMotorhomeTabs {
    title: IMotorhomeTabsTitles;
    name: IMotorhomeTabsNames;
    items?: FeatureList[];
    specifications?: {
        [key: string]: string;
    };
    excessReductionTable?: {
        excessReductionDescription: string;
        excessReductionFeatures: {
            name?: string;
            type?: string;
            basic?: string | boolean;
            standard?: string | boolean;
            full?: string | boolean;
        }[];
    };
}

export const BlockMotorhomeDetails = ({ fleet, id }: IComponentBlocksMotorhomeDetails) => {
    const router = useRouter();
    const region = router.locale === ILocales.en_NZ ? 'nz' : 'au';
    const motorhome = products?.find((product) => product.code === fleet && product.region === region);
    if (!motorhome) {
        return null;
    }

    const tabs: IMotorhomeTabs[] = [
        {
            title: IMotorhomeTabsTitles.Features,
            name: IMotorhomeTabsNames.Features,
            items: [...motorhome.features],
        },
        {
            title: IMotorhomeTabsTitles.Specifications,
            name: IMotorhomeTabsNames.Specifications,
            specifications: motorhome.specifications as unknown as {
                [key: string]: string;
            },
        },
        {
            title: IMotorhomeTabsTitles.ExcessReduction,
            name: IMotorhomeTabsNames.ExcessReduction,
            excessReductionTable: {
                excessReductionFeatures: motorhome.excessReductionFeatures,
                excessReductionDescription: motorhome.excessReductionDescription,
            },
        },
    ];

    return (
        <Container bg="shell" rounded={true} wrapperClassName={'py-16'}>
            <TitleAndDescription title={motorhome?.name} description={motorhome?.shortDescription} id={id} className="pb-10" />
            <MotorhomeTabContent tabItems={tabs} />
        </Container>
    );
};
